import { RolesPermissionType } from './roles-permissions.state';
import { OrganisationId } from '@portal-front-end/models';
import { createAction, props } from '@ngrx/store';

export const loadPermissionType = '[Permissions] Loading Permissions';
export const permisionLoadedType = '[Permissions] Loading Permissions Success';
export const permisionErrorType = '[Permissions] Loading Permissions Error';



export const loadingRolesPermissions = createAction(
    loadPermissionType,
    props<{ orgId: OrganisationId }>()
);

export const permissionLoaded = createAction(
    permisionLoadedType,
    props<{ permissions: RolesPermissionType }>()
);

export const permissionLoadingError = createAction(permisionErrorType);




